/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type AssociatedMessageNew_messageable$ref: FragmentReference;
declare export opaque type AssociatedMessageNew_messageable$fragmentType: AssociatedMessageNew_messageable$ref;
export type AssociatedMessageNew_messageable = {|
  +id: string,
  +title: string,
  +body: ?string,
  +backgroundImageUrl: ?string,
  +endDate: any,
  +$refType: AssociatedMessageNew_messageable$ref,
|};
export type AssociatedMessageNew_messageable$data = AssociatedMessageNew_messageable;
export type AssociatedMessageNew_messageable$key = {
  +$data?: AssociatedMessageNew_messageable$data,
  +$fragmentRefs: AssociatedMessageNew_messageable$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AssociatedMessageNew_messageable",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "body",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "backgroundImageUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endDate",
      "storageKey": null
    }
  ],
  "type": "Messageable"
};
// prettier-ignore
(node/*: any*/).hash = '35b2361f3a20d6b298e41eb8be2915ff';

module.exports = node;
